<script setup lang="ts">
import { computed } from 'vue';
import DateUtils from '@/utils/date-utils';

const props = defineProps<{
  id: number;
  name: string;
  messagePreview: string;
  timestamp: string;
}>();

const emit = defineEmits<{
  (e: 'clicked', id: number): void;
}>();

const initials = computed(() => {
  if (!props.name?.length) {
    return 'UK'; // unknown initials
  }

  return props.name
    .split(' ')
    .slice(0, 2)
    .map((part) => part[0])
    .join('');
});

const displayTimestamp = computed(() => DateUtils.formatTimestamp(props.timestamp, 'MMM D h:mma'));
</script>

<template>
  <button
    type="button"
    class="flex w-full items-start gap-3 border-b border-tint-80 bg-white p-4 text-left"
    data-test="mobile-activity-row"
    @click="emit('clicked', id)"
  >
    <div
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-tint-40 text-[13px] font-bold text-shade-800"
    >
      {{ initials }}
    </div>

    <div class="flex min-w-0 flex-1 flex-col gap-1">
      <div class="flex w-full items-center gap-2">
        <div class="flex min-w-0 flex-1 items-center gap-1">
          <span class="sensitive min-w-0 truncate text-sm font-bold leading-[21px] text-shade-880">
            {{ name }}
          </span>
          <span class="shrink-0 text-xs font-normal leading-[18px] text-shade-800">
            messaged you
          </span>
        </div>
        <span class="shrink-0 text-xs font-normal leading-[18px] text-shade-820">
          {{ displayTimestamp }}
        </span>
      </div>

      <p class="line-clamp-1 text-sm font-normal leading-5 text-shade-900">
        {{ messagePreview }}
      </p>
    </div>
  </button>
</template>
